import React, { Component } from "react";
import Image from "react-bootstrap/Image";
import {
  ReusableOnboardingStepButton,
  ReusableOnboardingFaqButton,
} from "../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { logOutUser } from "../../../../store/actions/authAction";

export class RightSidePannel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
    };
  }

  onLogoutClick = (e) => {
    e.preventDefault();
    this.props.logOutUser();
  };

  render() {
    return (
      <React.Fragment>
        <ReusableOnboardingFaqButton onClick={this.onLogoutClick} />
        <div className="onboarding_process_right_paddingBox">
          <div className="col-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 text-center onboarding-right-pannel-top-step">
            <ReusableOnboardingStepButton
              buttonText="1"
              buttonClass={
                this.props.selectedTab === 1
                  ? "onboarding_step_button_reusable onboarding_step_button_reusable_active"
                  : "onboarding_step_button_reusable"
              }
              buttonType="button"
              buttonTitle="Button Step"
            />
            <ReusableOnboardingStepButton
              buttonText="2"
              buttonClass={
                this.props.selectedTab === 2
                  ? "onboarding_step_button_reusable onboarding_step_button_reusable_active"
                  : "onboarding_step_button_reusable"
              }
              buttonType="button"
              buttonTitle="Button Step"
            />
            <ReusableOnboardingStepButton
              buttonText="3"
              buttonClass={
                this.props.selectedTab === 3
                  ? "onboarding_step_button_reusable onboarding_step_button_reusable_active"
                  : "onboarding_step_button_reusable"
              }
              buttonType="button"
              buttonTitle="Button Step"
            />
            <ReusableOnboardingStepButton
              buttonText="4"
              buttonClass={
                this.props.selectedTab === 4
                  ? "onboarding_step_button_reusable onboarding_step_button_reusable_active"
                  : "onboarding_step_button_reusable"
              }
              buttonType="button"
              buttonTitle="Button Step"
            />
          </div>
          <div className="col-12 onboarding_process_store_setup">
            <h4>{this.props.headingText}</h4>
            <div className="store_setup_Image">
              <Image
                src={this.props.imageSrc}
                fluid
                alt="store setup"
                title="store setup"
              />
            </div>
            <p>{this.props.paragraph}</p>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

RightSidePannel.propTypes = {
  logOutUser: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
});

export default connect(mapStateToProps, { logOutUser })(
  withRouter(RightSidePannel)
);
